import { useTranslation } from "react-i18next";

import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "@/components/Button/Button";

interface ViewHistoryButtonProps {
  toSm: boolean;
  handleOpenHistoryDialog: () => void;
}

const ViewHistoryButton = ({
  toSm,
  handleOpenHistoryDialog
}: ViewHistoryButtonProps) => {
  const { t } = useTranslation();

  const buttonParams = toSm
    ? {
        size: BUTTON_SIZES.Small,
        isFullWidth: true
      }
    : {
        size: BUTTON_SIZES.Tiny,
        isFullWidth: false
      };

  const { size, isFullWidth } = buttonParams;

  return (
    <Button
      data-testid="view-history-button"
      size={size}
      onClick={handleOpenHistoryDialog}
      color={BUTTON_COLORS.Secondary}
      variant={BUTTON_VARIANTS.TextOnly}
      fullWidth={isFullWidth}
      style={
        toSm
          ? {
              marginTop: "16px"
            }
          : {}
      }
    >
      {t("Dashboard##view history")}
    </Button>
  );
};

export default ViewHistoryButton;
